module.exports = __webpack_public_path__ + "static/media/72-luke-art.69c711e4.jpg";